import React from 'react';

function About() {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">Who We Are</h2>
        </div>
        <div className="row">
          <div className="col-lg-6 mb-4">
            <p className="about-text">
              <strong>BARQ ALWUSOOL BUSES RENTAL LLC</strong> is a professional passenger 
              transport company based in Dubai, providing safe, reliable, and comfortable 
              transportation services across all seven Emirates.
            </p>
            <p className="about-text">
              We serve corporate companies, schools, hotels, tourism agencies, event 
              organizers, and private groups with a modern fleet and trained drivers.
            </p>
          </div>
          <div className="col-lg-6">
            <div className="commitment-box">
              <h4 className="commitment-title">Our Commitment</h4>
              <ul className="commitment-list">
                <li>✓ On-time service</li>
                <li>✓ Clean and well-maintained vehicles</li>
                <li>✓ Professional, uniformed drivers</li>
                <li>✓ Transparent pricing</li>
                <li>✓ 24/7 customer support</li>
                <li>✓ Full RTA compliance</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;